import React, { useEffect, useContext } from 'react';
import AppContext from './context/app/appContext';
import Loading from './Loading';
import Main from './Main';
import AppHelper from './helpers/App';

function AppWrapper() {

    const appContext = useContext(AppContext);

    useEffect(() => {
        appContext.getData();
    }, []);

    useEffect(() => {
        if (!appContext.filterFromUrlSet && appContext.data.length) {

            const filter = AppHelper.getParameterByName('f');
            const value = AppHelper.getParameterByName('v');

            // clear slected format
            const clear = AppHelper.getParameterByName('cf');
            if ( clear != null ) {
                appContext.unsetSelectedOptions('f')
            }

            if ( filter === null || value === null ) {
                return;
            }

            // find value by title
            let found = Object.keys(appContext.dictionaries[filter])
                .filter(keyName => { 
                    if ( appContext.dictionaries[filter][keyName] !== null ) {
                        return appContext.dictionaries[filter][keyName].toLowerCase() === (value.toLowerCase()) 
                    }
                    return false
                });

            if (found.length) {
                appContext.toggleActiveFilter(filter);
                appContext.toggleSelectedOption({ filterIdent: filter, optionIdent: found[0] });
            }
        }
    }, [appContext.data]);

    return appContext.loaded ? (
        <div className="app-wrap">
            <Main />
        </div>
    ) : <Loading />;

}

export default (AppWrapper); 